//#region Libraries
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Images
import ClearIcon from "icons/ClearIcon";
import SearchIcon from "icons/SearchIcon";
//#endregion
//#region Utils
import { PROPS_CUSTOM_BUTTON, PROPS_CUSTOM_SELECT } from "./constants";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import useChangeRolesByCategory from "../../../../utils/hooks/useChangeRolesByCategory";
//#endregion

const Filters = ({
    filterFields,
    movePage,
    data: {
        categoryList,
        roleList
    },
    setTriggerRequest
}) => {
    //#region Functions
    const changeField = (field, value) => {
        movePage(1);
        filterFields.set(prev => ({
            ...prev,
            [field]: value
        }));
    }
    const changeNameSurnameOrUser = value => {
        changeField("nameSurnameOrUser", value);
    }
    const changeCategoryId = value => {
        changeField("categoryId", value);
    }
    const changeRoleId = value => {
        changeField("roleId", value);
    }
    const changeCreationDate = value => {
        changeField("creationDate", value);
    }
    const applyFilters = () => {
        setTriggerRequest(true);
    }
    //#endregion
    const { rolesByCategory } = useChangeRolesByCategory({
        categoryId: filterFields.value.categoryId,
        roleList,
        changeRoleField: changeRoleId
    });
    const filtersFieldsIsCleared = filterFields.isCleared();
    return (
        <Column marginTop="10px">
            <Row width="100%" align="flex-end">
                <Row justifyContent="flex-start" align="flex-end">
                    <CustomTextInput 
                        label="Buscador:"
                        placeholder="Escribe el nombre, apellido o usuario"
                        value={filterFields.value.nameSurnameOrUser}
                        onChange={changeNameSurnameOrUser}
                        minWidth="270px"/>
                    <CustomSelect 
                        {...PROPS_CUSTOM_SELECT}
                        label="Categoría:"
                        value={filterFields.value.categoryId}
                        optionsProps={getOptionsToCustomSelect(categoryList, { id: "id", text: "name" })}
                        onChange={changeCategoryId}
                        defaultOptionText="Elige una categoría"/>
                    <CustomSelect 
                        {...PROPS_CUSTOM_SELECT}
                        label="Rol:"
                        value={filterFields.value.roleId}
                        optionsProps={getOptionsToCustomSelect(rolesByCategory, { id: "id", text: "name" })}
                        onChange={changeRoleId}
                        disabled={rolesByCategory.length === 0}
                        defaultOptionText="Elige un rol"/>
                    <CustomDatePicker 
                        label="Creación:"
                        value={filterFields.value.creationDate}
                        onChange={changeCreationDate}
                        period = {{
                            min: [2000, 1, 1],
                            max: [3000, 1, 1]
                        }}/>
                </Row>
                <Row>
                    <CustomButton 
                        {...PROPS_CUSTOM_BUTTON}
                        onClick={applyFilters}
                        icon={<SearchIcon/>}
                        text="Aplicar"
                        width="100px"/>
                    <CustomButton 
                        {...PROPS_CUSTOM_BUTTON}
                        disabled= {filtersFieldsIsCleared}
                        onClick={filterFields.clear}
                        variant={filtersFieldsIsCleared ? "primary" : "secondary"}
                        icon={<ClearIcon/>}
                        text="Limpiar"/>
                </Row>
            </Row>
        </Column>
    );
}

export default Filters;